// extracted by mini-css-extract-plugin
module.exports = {"m--nav-item":"NavItem_m--nav-item__EIexY","m--label":"NavItem_m--label__FfyW8"};